import Joi from "joi";

export let assetActionSchema = Joi.object({
  title: Joi.string().min(2).required().label("Title"),
  assetActionTypeId: Joi.string().min(2).required().label("AssetActionType"),
  amount: Joi.number().min(0).required().label("Amount"),
  date: Joi.date().required().label("Date"),
  description: Joi.string().min(2).required().label("Description"),
  assetId: Joi.string().min(2).required().label("Asset"),
});
